export default "__VITE_ASSET__CnGBNGfv__"